/**
 * Default path to use for the microfrontends configuration when output to a file.
 */
export const MFE_CONFIG_DEFAULT_FILE_PATH = 'microfrontends' as const;

/**
 * Default name to use for the microfrontends configuration when output to a file.
 */
export const MFE_CONFIG_DEFAULT_FILE_NAME = 'microfrontends.json' as const;
